/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AddClientTeamMember200Response,
    AddClientTeamMember200ResponseFromJSON,
    AddClientTeamMember200ResponseToJSON,
} from '../models/AddClientTeamMember200Response';
import {
    type AddServiceproviderTeamMemberRequest,
    AddServiceproviderTeamMemberRequestFromJSON,
    AddServiceproviderTeamMemberRequestToJSON,
} from '../models/AddServiceproviderTeamMemberRequest';
import {
    type CreateApiAccount201Response,
    CreateApiAccount201ResponseFromJSON,
    CreateApiAccount201ResponseToJSON,
} from '../models/CreateApiAccount201Response';
import {
    type CreateApiAccount403Response,
    CreateApiAccount403ResponseFromJSON,
    CreateApiAccount403ResponseToJSON,
} from '../models/CreateApiAccount403Response';
import {
    type CreateApiAccount409Response,
    CreateApiAccount409ResponseFromJSON,
    CreateApiAccount409ResponseToJSON,
} from '../models/CreateApiAccount409Response';
import {
    type CreateApiAccountRequest,
    CreateApiAccountRequestFromJSON,
    CreateApiAccountRequestToJSON,
} from '../models/CreateApiAccountRequest';
import {
    type CreateServiceprovider201Response,
    CreateServiceprovider201ResponseFromJSON,
    CreateServiceprovider201ResponseToJSON,
} from '../models/CreateServiceprovider201Response';
import {
    type CreateServiceproviderRequest,
    CreateServiceproviderRequestFromJSON,
    CreateServiceproviderRequestToJSON,
} from '../models/CreateServiceproviderRequest';
import {
    type CreateSupportRequest400Response,
    CreateSupportRequest400ResponseFromJSON,
    CreateSupportRequest400ResponseToJSON,
} from '../models/CreateSupportRequest400Response';
import {
    type DeleteReseller200Response,
    DeleteReseller200ResponseFromJSON,
    DeleteReseller200ResponseToJSON,
} from '../models/DeleteReseller200Response';
import {
    type GetClientTeam200ResponseInner,
    GetClientTeam200ResponseInnerFromJSON,
    GetClientTeam200ResponseInnerToJSON,
} from '../models/GetClientTeam200ResponseInner';
import {
    type GetCustomEmailSettings200Response,
    GetCustomEmailSettings200ResponseFromJSON,
    GetCustomEmailSettings200ResponseToJSON,
} from '../models/GetCustomEmailSettings200Response';
import {
    type GetServiceprovider200Response,
    GetServiceprovider200ResponseFromJSON,
    GetServiceprovider200ResponseToJSON,
} from '../models/GetServiceprovider200Response';
import {
    type GetServiceproviderOnboardingStatus200Response,
    GetServiceproviderOnboardingStatus200ResponseFromJSON,
    GetServiceproviderOnboardingStatus200ResponseToJSON,
} from '../models/GetServiceproviderOnboardingStatus200Response';
import {
    type GetWellKnownEmailServices401Response,
    GetWellKnownEmailServices401ResponseFromJSON,
    GetWellKnownEmailServices401ResponseToJSON,
} from '../models/GetWellKnownEmailServices401Response';
import {
    type GetWellKnownEmailServices500Response,
    GetWellKnownEmailServices500ResponseFromJSON,
    GetWellKnownEmailServices500ResponseToJSON,
} from '../models/GetWellKnownEmailServices500Response';
import {
    type IsClientExisting200Response,
    IsClientExisting200ResponseFromJSON,
    IsClientExisting200ResponseToJSON,
} from '../models/IsClientExisting200Response';
import {
    type ListApiAccounts200ResponseInner,
    ListApiAccounts200ResponseInnerFromJSON,
    ListApiAccounts200ResponseInnerToJSON,
} from '../models/ListApiAccounts200ResponseInner';
import {
    type RemoveClientTeamMemberRequest,
    RemoveClientTeamMemberRequestFromJSON,
    RemoveClientTeamMemberRequestToJSON,
} from '../models/RemoveClientTeamMemberRequest';
import {
    type RotateApiAccountPassword200Response,
    RotateApiAccountPassword200ResponseFromJSON,
    RotateApiAccountPassword200ResponseToJSON,
} from '../models/RotateApiAccountPassword200Response';
import {
    type SendCustomTestEmailRequest,
    SendCustomTestEmailRequestFromJSON,
    SendCustomTestEmailRequestToJSON,
} from '../models/SendCustomTestEmailRequest';
import {
    type SetCustomEmailSettingsRequest,
    SetCustomEmailSettingsRequestFromJSON,
    SetCustomEmailSettingsRequestToJSON,
} from '../models/SetCustomEmailSettingsRequest';
import {
    type SetQuickcheckSettingsRequest,
    SetQuickcheckSettingsRequestFromJSON,
    SetQuickcheckSettingsRequestToJSON,
} from '../models/SetQuickcheckSettingsRequest';
import {
    type UpdateServiceproviderRequest,
    UpdateServiceproviderRequestFromJSON,
    UpdateServiceproviderRequestToJSON,
} from '../models/UpdateServiceproviderRequest';

export interface AddServiceproviderTeamMemberOperationRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    addServiceproviderTeamMemberRequest: AddServiceproviderTeamMemberRequest;
}

export interface CreateApiAccountOperationRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    createApiAccountRequest: CreateApiAccountRequest;
}

export interface CreateServiceproviderOperationRequest {
    /**
     * 
     */
    createServiceproviderRequest: CreateServiceproviderRequest;
}

export interface DeleteApiAccountRequest {
    /**
     * 
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    accountId: string;
}

export interface DeleteServiceproviderRequest {
    /**
     * 
     */
    serviceproviderUUID: string;
}

export interface GetCustomEmailSettingsRequest {
    /**
     * 
     */
    serviceproviderUUID: string;
}

export interface GetLogoRequest {
    /**
     * 
     */
    serviceproviderUUID: string;
}

export interface GetServiceProviderTeamRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
}

export interface GetServiceproviderRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
}

export interface GetServiceproviderOnboardingStatusRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
}

export interface IsClientExistingRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * UUID of the client to check.
     */
    clientUUID: string;
}

export interface ListApiAccountsRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
}

export interface RemoveServiceproviderTeamMemberRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    removeClientTeamMemberRequest: RemoveClientTeamMemberRequest;
}

export interface RotateApiAccountPasswordRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * UUID of the API account to rotate.
     */
    accountId: string;
}

export interface SendCustomTestEmailOperationRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    sendCustomTestEmailRequest: SendCustomTestEmailRequest;
}

export interface SetCustomEmailSettingsOperationRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    setCustomEmailSettingsRequest: SetCustomEmailSettingsRequest;
}

export interface SetQuickcheckSettingsOperationRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    setQuickcheckSettingsRequest: SetQuickcheckSettingsRequest;
}

export interface UpdateServiceproviderOperationRequest {
    /**
     * UUID of the serviceprovider.
     */
    serviceproviderUUID: string;
    /**
     * 
     */
    updateServiceproviderRequest: UpdateServiceproviderRequest;
}

export interface UploadLogoRequest {
    /**
     * 
     */
    serviceproviderUUID: string;
}

/**
 * 
 */
export class ServiceproviderApi extends runtime.BaseAPI {

    /**
     * Creates request options for addServiceproviderTeamMember without sending the request
     */
    async addServiceproviderTeamMemberRequestOpts(requestParameters: AddServiceproviderTeamMemberOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling addServiceproviderTeamMember().'
            );
        }

        if (requestParameters['addServiceproviderTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'addServiceproviderTeamMemberRequest',
                'Required parameter "addServiceproviderTeamMemberRequest" was null or undefined when calling addServiceproviderTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/collaboration/team`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddServiceproviderTeamMemberRequestToJSON(requestParameters['addServiceproviderTeamMemberRequest']),
        };
    }

    /**
     * Adds a new member to the serviceprovider team. A Keycloak account is created and the user receives an invitation email to set their password.
     * Add team member
     */
    async addServiceproviderTeamMemberRaw(requestParameters: AddServiceproviderTeamMemberOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddClientTeamMember200Response>> {
        const requestOptions = await this.addServiceproviderTeamMemberRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddClientTeamMember200ResponseFromJSON(jsonValue));
    }

    /**
     * Adds a new member to the serviceprovider team. A Keycloak account is created and the user receives an invitation email to set their password.
     * Add team member
     */
    async addServiceproviderTeamMember(serviceproviderUUID: string, addServiceproviderTeamMemberRequest: AddServiceproviderTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddClientTeamMember200Response> {
        const response = await this.addServiceproviderTeamMemberRaw({ serviceproviderUUID: serviceproviderUUID, addServiceproviderTeamMemberRequest: addServiceproviderTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createApiAccount without sending the request
     */
    async createApiAccountRequestOpts(requestParameters: CreateApiAccountOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling createApiAccount().'
            );
        }

        if (requestParameters['createApiAccountRequest'] == null) {
            throw new runtime.RequiredError(
                'createApiAccountRequest',
                'Required parameter "createApiAccountRequest" was null or undefined when calling createApiAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/api/accounts`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateApiAccountRequestToJSON(requestParameters['createApiAccountRequest']),
        };
    }

    /**
     * Creates an API account for machine-to-machine access to the customer API. Use `type: \"sp\"` for access across all clients of this serviceprovider, or `type: \"client\"` to scope access to a single client.  **Important:** The password is returned only once on creation — store it securely.
     * Create API account
     */
    async createApiAccountRaw(requestParameters: CreateApiAccountOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateApiAccount201Response>> {
        const requestOptions = await this.createApiAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateApiAccount201ResponseFromJSON(jsonValue));
    }

    /**
     * Creates an API account for machine-to-machine access to the customer API. Use `type: \"sp\"` for access across all clients of this serviceprovider, or `type: \"client\"` to scope access to a single client.  **Important:** The password is returned only once on creation — store it securely.
     * Create API account
     */
    async createApiAccount(serviceproviderUUID: string, createApiAccountRequest: CreateApiAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateApiAccount201Response> {
        const response = await this.createApiAccountRaw({ serviceproviderUUID: serviceproviderUUID, createApiAccountRequest: createApiAccountRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createServiceprovider without sending the request
     */
    async createServiceproviderRequestOpts(requestParameters: CreateServiceproviderOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createServiceproviderRequest'] == null) {
            throw new runtime.RequiredError(
                'createServiceproviderRequest',
                'Required parameter "createServiceproviderRequest" was null or undefined when calling createServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateServiceproviderRequestToJSON(requestParameters['createServiceproviderRequest']),
        };
    }

    /**
     * Create a new serviceprovider
     */
    async createServiceproviderRaw(requestParameters: CreateServiceproviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateServiceprovider201Response>> {
        const requestOptions = await this.createServiceproviderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateServiceprovider201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new serviceprovider
     */
    async createServiceprovider(createServiceproviderRequest: CreateServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateServiceprovider201Response> {
        const response = await this.createServiceproviderRaw({ createServiceproviderRequest: createServiceproviderRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteApiAccount without sending the request
     */
    async deleteApiAccountRequestOpts(requestParameters: DeleteApiAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling deleteApiAccount().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling deleteApiAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/api/accounts/{accountId}`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Permanently deletes an API account. Any integrations using this account will immediately lose access.
     * Delete API account
     */
    async deleteApiAccountRaw(requestParameters: DeleteApiAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.deleteApiAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Permanently deletes an API account. Any integrations using this account will immediately lose access.
     * Delete API account
     */
    async deleteApiAccount(serviceproviderUUID: string, accountId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.deleteApiAccountRaw({ serviceproviderUUID: serviceproviderUUID, accountId: accountId }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteServiceprovider without sending the request
     */
    async deleteServiceproviderRequestOpts(requestParameters: DeleteServiceproviderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling deleteServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Permanently deletes the serviceprovider account and all associated data. This action is irreversible.
     * Delete serviceprovider
     */
    async deleteServiceproviderRaw(requestParameters: DeleteServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.deleteServiceproviderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Permanently deletes the serviceprovider account and all associated data. This action is irreversible.
     * Delete serviceprovider
     */
    async deleteServiceprovider(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.deleteServiceproviderRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getCustomEmailSettings without sending the request
     */
    async getCustomEmailSettingsRequestOpts(requestParameters: GetCustomEmailSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getCustomEmailSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/email/settings`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the current custom SMTP email configuration. Sensitive values (passwords, OAuth2 secrets) are not included in the response.
     * Get custom email settings
     */
    async getCustomEmailSettingsRaw(requestParameters: GetCustomEmailSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCustomEmailSettings200Response>> {
        const requestOptions = await this.getCustomEmailSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCustomEmailSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the current custom SMTP email configuration. Sensitive values (passwords, OAuth2 secrets) are not included in the response.
     * Get custom email settings
     */
    async getCustomEmailSettings(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCustomEmailSettings200Response> {
        const response = await this.getCustomEmailSettingsRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getLogo without sending the request
     */
    async getLogoRequestOpts(requestParameters: GetLogoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/whitelabel/logo`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the serviceprovider whitelabel logo as binary image data
     */
    async getLogoRaw(requestParameters: GetLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.getLogoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get the serviceprovider whitelabel logo as binary image data
     */
    async getLogo(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getLogoRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
    }

    /**
     * Creates request options for getServiceProviderTeam without sending the request
     */
    async getServiceProviderTeamRequestOpts(requestParameters: GetServiceProviderTeamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getServiceProviderTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/collaboration/team`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all team members of the serviceprovider.
     * Get team members
     */
    async getServiceProviderTeamRaw(requestParameters: GetServiceProviderTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetClientTeam200ResponseInner>>> {
        const requestOptions = await this.getServiceProviderTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetClientTeam200ResponseInnerFromJSON));
    }

    /**
     * Returns all team members of the serviceprovider.
     * Get team members
     */
    async getServiceProviderTeam(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetClientTeam200ResponseInner>> {
        const response = await this.getServiceProviderTeamRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceprovider without sending the request
     */
    async getServiceproviderRequestOpts(requestParameters: GetServiceproviderRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns details about the serviceprovider account, including whitelabel configuration, license status, client count, and quickcheck portal settings.
     * Get serviceprovider details
     */
    async getServiceproviderRaw(requestParameters: GetServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetServiceprovider200Response>> {
        const requestOptions = await this.getServiceproviderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetServiceprovider200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns details about the serviceprovider account, including whitelabel configuration, license status, client count, and quickcheck portal settings.
     * Get serviceprovider details
     */
    async getServiceprovider(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetServiceprovider200Response> {
        const response = await this.getServiceproviderRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getServiceproviderOnboardingStatus without sending the request
     */
    async getServiceproviderOnboardingStatusRequestOpts(requestParameters: GetServiceproviderOnboardingStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling getServiceproviderOnboardingStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/onboarding`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns which onboarding steps of the serviceprovider are done, derived from its data.  **Authorized Roles:** `serviceprovider`, `admin`
     * Get onboarding status
     */
    async getServiceproviderOnboardingStatusRaw(requestParameters: GetServiceproviderOnboardingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetServiceproviderOnboardingStatus200Response>> {
        const requestOptions = await this.getServiceproviderOnboardingStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetServiceproviderOnboardingStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns which onboarding steps of the serviceprovider are done, derived from its data.  **Authorized Roles:** `serviceprovider`, `admin`
     * Get onboarding status
     */
    async getServiceproviderOnboardingStatus(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetServiceproviderOnboardingStatus200Response> {
        const response = await this.getServiceproviderOnboardingStatusRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for isClientExisting without sending the request
     */
    async isClientExistingRequestOpts(requestParameters: IsClientExistingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling isClientExisting().'
            );
        }

        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling isClientExisting().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/clients/{clientUUID}/status`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Check whether a client has been fully initialized. Client creation is asynchronous — poll this endpoint until `exists` is `true` before accessing client-specific endpoints.
     * Check client initialization status
     */
    async isClientExistingRaw(requestParameters: IsClientExistingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IsClientExisting200Response>> {
        const requestOptions = await this.isClientExistingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IsClientExisting200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a client has been fully initialized. Client creation is asynchronous — poll this endpoint until `exists` is `true` before accessing client-specific endpoints.
     * Check client initialization status
     */
    async isClientExisting(serviceproviderUUID: string, clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IsClientExisting200Response> {
        const response = await this.isClientExistingRaw({ serviceproviderUUID: serviceproviderUUID, clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listApiAccounts without sending the request
     */
    async listApiAccountsRequestOpts(requestParameters: ListApiAccountsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling listApiAccounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/api/accounts`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all API accounts belonging to this serviceprovider. API accounts are used for machine-to-machine authentication to access the customer API.
     * List API accounts
     */
    async listApiAccountsRaw(requestParameters: ListApiAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListApiAccounts200ResponseInner>>> {
        const requestOptions = await this.listApiAccountsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListApiAccounts200ResponseInnerFromJSON));
    }

    /**
     * Returns all API accounts belonging to this serviceprovider. API accounts are used for machine-to-machine authentication to access the customer API.
     * List API accounts
     */
    async listApiAccounts(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListApiAccounts200ResponseInner>> {
        const response = await this.listApiAccountsRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for removeServiceproviderTeamMember without sending the request
     */
    async removeServiceproviderTeamMemberRequestOpts(requestParameters: RemoveServiceproviderTeamMemberRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling removeServiceproviderTeamMember().'
            );
        }

        if (requestParameters['removeClientTeamMemberRequest'] == null) {
            throw new runtime.RequiredError(
                'removeClientTeamMemberRequest',
                'Required parameter "removeClientTeamMemberRequest" was null or undefined when calling removeServiceproviderTeamMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/collaboration/team`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveClientTeamMemberRequestToJSON(requestParameters['removeClientTeamMemberRequest']),
        };
    }

    /**
     * Removes a user from the serviceprovider team and deletes their Keycloak account.
     * Remove team member
     */
    async removeServiceproviderTeamMemberRaw(requestParameters: RemoveServiceproviderTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.removeServiceproviderTeamMemberRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Removes a user from the serviceprovider team and deletes their Keycloak account.
     * Remove team member
     */
    async removeServiceproviderTeamMember(serviceproviderUUID: string, removeClientTeamMemberRequest: RemoveClientTeamMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.removeServiceproviderTeamMemberRaw({ serviceproviderUUID: serviceproviderUUID, removeClientTeamMemberRequest: removeClientTeamMemberRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rotateApiAccountPassword without sending the request
     */
    async rotateApiAccountPasswordRequestOpts(requestParameters: RotateApiAccountPasswordRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling rotateApiAccountPassword().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling rotateApiAccountPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/api/accounts/{accountId}/rotate`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));
        urlPath = urlPath.replace('{accountId}', encodeURIComponent(String(requestParameters['accountId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generates a new password for an existing API account and invalidates the previous one. Update any integrations using this account before rotating.  **Important:** The new password is returned only once — store it securely.
     * Rotate API account password
     */
    async rotateApiAccountPasswordRaw(requestParameters: RotateApiAccountPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RotateApiAccountPassword200Response>> {
        const requestOptions = await this.rotateApiAccountPasswordRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RotateApiAccountPassword200ResponseFromJSON(jsonValue));
    }

    /**
     * Generates a new password for an existing API account and invalidates the previous one. Update any integrations using this account before rotating.  **Important:** The new password is returned only once — store it securely.
     * Rotate API account password
     */
    async rotateApiAccountPassword(serviceproviderUUID: string, accountId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RotateApiAccountPassword200Response> {
        const response = await this.rotateApiAccountPasswordRaw({ serviceproviderUUID: serviceproviderUUID, accountId: accountId }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendCustomTestEmail without sending the request
     */
    async sendCustomTestEmailRequestOpts(requestParameters: SendCustomTestEmailOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling sendCustomTestEmail().'
            );
        }

        if (requestParameters['sendCustomTestEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendCustomTestEmailRequest',
                'Required parameter "sendCustomTestEmailRequest" was null or undefined when calling sendCustomTestEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/email/test`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendCustomTestEmailRequestToJSON(requestParameters['sendCustomTestEmailRequest']),
        };
    }

    /**
     * Sends a test email using the currently saved custom email settings to verify delivery works correctly.
     * Send test email
     */
    async sendCustomTestEmailRaw(requestParameters: SendCustomTestEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.sendCustomTestEmailRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Sends a test email using the currently saved custom email settings to verify delivery works correctly.
     * Send test email
     */
    async sendCustomTestEmail(serviceproviderUUID: string, sendCustomTestEmailRequest: SendCustomTestEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.sendCustomTestEmailRaw({ serviceproviderUUID: serviceproviderUUID, sendCustomTestEmailRequest: sendCustomTestEmailRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setCustomEmailSettings without sending the request
     */
    async setCustomEmailSettingsRequestOpts(requestParameters: SetCustomEmailSettingsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling setCustomEmailSettings().'
            );
        }

        if (requestParameters['setCustomEmailSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'setCustomEmailSettingsRequest',
                'Required parameter "setCustomEmailSettingsRequest" was null or undefined when calling setCustomEmailSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/email/settings`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetCustomEmailSettingsRequestToJSON(requestParameters['setCustomEmailSettingsRequest']),
        };
    }

    /**
     * Configure custom SMTP email delivery for this serviceprovider. When enabled, security notifications are sent from this server instead of the default SEC AUDITOR mailer. Supports basic (username/password) and OAuth2 authentication.
     * Configure custom email settings
     */
    async setCustomEmailSettingsRaw(requestParameters: SetCustomEmailSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.setCustomEmailSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Configure custom SMTP email delivery for this serviceprovider. When enabled, security notifications are sent from this server instead of the default SEC AUDITOR mailer. Supports basic (username/password) and OAuth2 authentication.
     * Configure custom email settings
     */
    async setCustomEmailSettings(serviceproviderUUID: string, setCustomEmailSettingsRequest: SetCustomEmailSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.setCustomEmailSettingsRaw({ serviceproviderUUID: serviceproviderUUID, setCustomEmailSettingsRequest: setCustomEmailSettingsRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setQuickcheckSettings without sending the request
     */
    async setQuickcheckSettingsRequestOpts(requestParameters: SetQuickcheckSettingsOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling setQuickcheckSettings().'
            );
        }

        if (requestParameters['setQuickcheckSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'setQuickcheckSettingsRequest',
                'Required parameter "setQuickcheckSettingsRequest" was null or undefined when calling setQuickcheckSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/quickcheck/settings`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetQuickcheckSettingsRequestToJSON(requestParameters['setQuickcheckSettingsRequest']),
        };
    }

    /**
     * Configure the quickcheck portal settings for this serviceprovider. The origin URL controls where the portal is accessible from; the privacy URL is displayed to end users in the portal.
     * Set quickcheck portal settings
     */
    async setQuickcheckSettingsRaw(requestParameters: SetQuickcheckSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.setQuickcheckSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Configure the quickcheck portal settings for this serviceprovider. The origin URL controls where the portal is accessible from; the privacy URL is displayed to end users in the portal.
     * Set quickcheck portal settings
     */
    async setQuickcheckSettings(serviceproviderUUID: string, setQuickcheckSettingsRequest: SetQuickcheckSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.setQuickcheckSettingsRaw({ serviceproviderUUID: serviceproviderUUID, setQuickcheckSettingsRequest: setQuickcheckSettingsRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateServiceprovider without sending the request
     */
    async updateServiceproviderRequestOpts(requestParameters: UpdateServiceproviderOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling updateServiceprovider().'
            );
        }

        if (requestParameters['updateServiceproviderRequest'] == null) {
            throw new runtime.RequiredError(
                'updateServiceproviderRequest',
                'Required parameter "updateServiceproviderRequest" was null or undefined when calling updateServiceprovider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/whitelabel/`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateServiceproviderRequestToJSON(requestParameters['updateServiceproviderRequest']),
        };
    }

    /**
     * Updates the serviceprovider\'s company details used for whitelabeling — displayed to clients in the dashboard and emails.
     * Update serviceprovider details
     */
    async updateServiceproviderRaw(requestParameters: UpdateServiceproviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.updateServiceproviderRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the serviceprovider\'s company details used for whitelabeling — displayed to clients in the dashboard and emails.
     * Update serviceprovider details
     */
    async updateServiceprovider(serviceproviderUUID: string, updateServiceproviderRequest: UpdateServiceproviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.updateServiceproviderRaw({ serviceproviderUUID: serviceproviderUUID, updateServiceproviderRequest: updateServiceproviderRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadLogo without sending the request
     */
    async uploadLogoRequestOpts(requestParameters: UploadLogoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['serviceproviderUUID'] == null) {
            throw new runtime.RequiredError(
                'serviceproviderUUID',
                'Required parameter "serviceproviderUUID" was null or undefined when calling uploadLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/serviceprovider/{serviceproviderUUID}/whitelabel/logo`;
        urlPath = urlPath.replace('{serviceproviderUUID}', encodeURIComponent(String(requestParameters['serviceproviderUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Upload a PNG or JPEG image to use as the serviceprovider whitelabel logo. The logo is displayed in the client dashboard and email notifications.
     * Upload whitelabel logo
     */
    async uploadLogoRaw(requestParameters: UploadLogoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.uploadLogoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Upload a PNG or JPEG image to use as the serviceprovider whitelabel logo. The logo is displayed in the client dashboard and email notifications.
     * Upload whitelabel logo
     */
    async uploadLogo(serviceproviderUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadLogoRaw({ serviceproviderUUID: serviceproviderUUID }, initOverrides);
    }

}
